import { useFetchHealthMailLoginDetails } from "features/results/hooks/useHealthMailLoginDetails";

export const HealthmailLoginInfo = () => {
  const { data: healthMailLoginDetails } = useFetchHealthMailLoginDetails();

  return (
    <>
      {healthMailLoginDetails?.token && (
        <div>
          <p>Healthmail connected</p>
          <p>Email address: {healthMailLoginDetails.email}</p>
        </div>
      )}
    </>
  );
};
